(function(){
var d=document,w=window,reduce=w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches;
var hdr=d.querySelector('.site-header'),tk=false;
var amb=d.querySelector('[data-ab-ambient]'),aw=amb&&amb.querySelector('.warm'),ac=amb&&amb.querySelector('.cool');
function ab(){if(!amb||reduce){return}var h=d.documentElement.scrollHeight-w.innerHeight,y=w.pageYOffset||d.documentElement.scrollTop,p=h>0?Math.min(1,Math.max(0,y/h)):0;aw.style.opacity=(1-p).toFixed(3);ac.style.opacity=p.toFixed(3)}
function s(){tk=false;var y=w.pageYOffset||d.documentElement.scrollTop;if(hdr){hdr.classList.toggle('is-scrolled',y>12)}ab()}
w.addEventListener('scroll',function(){if(!tk){tk=true;w.requestAnimationFrame(s)}},{passive:true});s();
if(reduce){return}
var sel='.section-heading,.feature-card,.trust-item,.faq-item,.jr-card,.newsletter,.product-art,.product-panel,.cmp-story-copy,.cmp-glass,.cmp-wrap,.cmp-hero .page-width>*,.bed-visual,.step,.split>*,.rsplit-copy,.rsplit-media,.rassure-item,.rfact,.rroute,.rdetails details,.rflow li,.rstate .page-width>*,.cmp-cta .page-width>*,.rc-cart-item,.rc-cart-summary,.rrelated,.rfaq-nav,.ab-cinema .page-width>*,.ab-ed-copy>*:not(.ab-icons),.ab-icons li,.ab-ed-media,.ab-manifesto h2,.ab-manifesto .sub,.ab-lines p,.ab-manifesto .closing,.ab-principle';
if('IntersectionObserver' in w){
var vh=w.innerHeight;
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var el=e.target;el.classList.remove('rc-hide');io.unobserve(el);setTimeout(function(){el.classList.remove('rc-reveal');el.style.removeProperty('--d')},1200)}})},{rootMargin:'0px 0px -6% 0px',threshold:.06});
[].forEach.call(d.querySelectorAll(sel),function(el){
var r=el.getBoundingClientRect();
if(r.top<vh*.92&&r.bottom>0){return}
var i=[].indexOf.call(el.parentNode.children,el);
el.style.setProperty('--d',Math.min(i,4)*80+'ms');
el.classList.add('rc-reveal','rc-hide');
io.observe(el);
});
}
if(w.matchMedia&&w.matchMedia('(hover:hover) and (pointer:fine)').matches){
var raf=0,t,ex,ey;
d.addEventListener('pointermove',function(e){
var c=e.target.closest&&e.target.closest('.feature-card,.jr-card,.cmp-glass,.rassure-item,.rfact,.rroute');
if(!c){return}
ex=e.clientX;ey=e.clientY;t=c;
if(!raf){raf=w.requestAnimationFrame(function(){raf=0;var r=t.getBoundingClientRect();t.style.setProperty('--mx',(ex-r.left)+'px');t.style.setProperty('--my',(ey-r.top)+'px')})}
},{passive:true});
}
})();
